// Alight brend logosi — "A" + yorug'lik uchquni motifi.
// mark: faqat emblema; full: emblema + "ALIGHT" so'zi.

export function LogoMark({ size = 40, badge = true }: { size?: number; badge?: boolean }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        {/* Kelvin shkalasi: 3000K (iliq) → 6500K (sovuq kunduzgi) */}
        <linearGradient id="alg" x1="15" y1="10" x2="85" y2="92" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ffb24d" />
          <stop offset="0.55" stopColor="#ffd9a8" />
          <stop offset="1" stopColor="#bcd8ff" />
        </linearGradient>
      </defs>
      {badge && <rect x="4" y="4" width="92" height="92" rx="24" fill="url(#alg)" />}
      <g stroke={badge ? '#1b1204' : 'url(#alg)'} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M30 74 L50 30 L70 74" />
        <path d="M39 58 H61" />
      </g>
      {/* yorug'lik uchquni */}
      <circle cx="50" cy="21" r="6.5" fill={badge ? '#1b1204' : '#ffb24d'} />
      <g stroke={badge ? '#1b1204' : '#ffb24d'} strokeWidth="3.4" strokeLinecap="round" opacity="0.9">
        <path d="M50 6 V12" />
        <path d="M36 12 L39.5 16.5" />
        <path d="M64 12 L60.5 16.5" />
      </g>
    </svg>
  );
}

export function LogoFull({ height = 34 }: { height?: number }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <LogoMark size={height} />
      <div style={{ lineHeight: 1 }}>
        <div style={{ fontWeight: 800, letterSpacing: 1.5, fontSize: height * 0.5 }}>ALIGHT</div>
        <div style={{ fontSize: height * 0.24, letterSpacing: 2, color: 'var(--muted)', fontWeight: 600 }}>IMPORT MANAGER</div>
      </div>
    </div>
  );
}
